import React, { useMemo, useState } from 'react'
import CustomSearch from '../../components/search/CustomSearch'
import { Button, message, Space, Spin, Table, Tooltip } from 'antd'
import Pnation from '../../components/Pagination/pagination'
import MotionIconButton from '../../components/icons/MotionIcon';
import { Link } from 'react-router-dom';
import { downloadFile, limitWords } from '../../utils/utils';
import FileTextIcon from '../../components/icons/FileTextIcon';
import RightArrowIcon from '../../components/icons/RightArrowIcon';
import fetchWithAuth from '../../utils/customFetch';

const BoldPlusIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
  </svg>
);
export default function Listing() {
    const [isLoading, setIsloading] = useState(false);
    const [allData, setAllData] = useState([])
    const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '' });


    const columns = useMemo(() => 
        [{
            title: "Name",
            dataIndex: "party_name",
            render: (userName, record) => (
                <span style={{ fontWeight: !record.is_read ? "normal" : "bold" }}>
                    {userName}
                </span>
            ),
        },
        {
            title: <Tooltip className="whitespace-nowrap" title="Description">Description</Tooltip>,
            dataIndex: "description",
            render: (text, record) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontWeight: !record.is_read ? "normal" : "bold",
                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: <Tooltip className="whitespace-nowrap" title="Execution File">Document Type</Tooltip>,
            dataIndex: "name_of_client",
            render: (text, record) => (
                record.document_type
            ),
        },
        {
            title: "Execution File",
            dataIndex: "agreement",
            render: (text, record) => (
                <>
                    <Button
                        onClick={() =>{
                            if(!record.execution_file){
                                message.error('File not exist .');
                                return false
                            }
                             downloadFile(record.execution_file)
                            }}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "Executed File",
            dataIndex: "agreement",
            render: (text, record) => (
                <>
                    <Button
                        onClick={() =>{
                                if(!record.executed_file){
                                message.error('File not exist .');
                                return false
                            }
                            downloadFile(record.executed_file)}}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
            {
            title: "View details",
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => (
                <Link
                    to={`/admin/esign/details/${record.id}?referrer=dashboard&tab=details`}
                >
                    <button
                        type="submit"
                       
                    >
                        <RightArrowIcon />
                    </button>
                </Link>
            ),
        }

        ]
    , [])

    const onPeding = (val) => {
        setIsloading(val)
    }
    const getData = (data) => {
        setAllData(data)
    }
    const handleSearch = (value) => {
        setSearchKeyword((val) => {
            val.search_keyword = value;
            return { ...val }
        })
    };
    return (
        <div>
            <div className="mb-6 flex flex-row justify-between ">
                <Space>
                    <span>
                        <h1
                            className="mt-1 text-lg font-[700] text-[30px] "
                        >
                            E-sign
                        </h1>
                    </span>
                </Space>
                <Link to="/admin/esign/create_esign" >
                    <MotionIconButton tooltip="Add E-sign" icon={<BoldPlusIcon />} onClick={() => { }} />
                </Link>
            </div>
            <div className=" text-black pb-3  flex justify-right">
                {/* <Space> */}
                <div className="mr-6">
                    <CustomSearch onSearch={handleSearch} /></div>
                {/* <EditorSwitch state1={'All'} state2={'Editor'} isLoading={isLoading} handleSwitchChange={handleSwitchChange} /> */}
                {/* </Space> */}
            </div>
            <div className="  border border-gray-300">

                <Spin spinning={isLoading} tip="Loading...">
                    <Table
                        columns={columns}
                        dataSource={allData}
                        scroll={{ x: "max-content", y: 400 }}
                        tableLayout="fixed"
                        pagination={false}
                    />
                </Spin>
            </div>
            {/* {data ? (Object.keys(searchKeyword).length > 4 && <Pnation onPeding={onPeding} onCngPage={getData} url='/contract/get/' plod={searchKeyword} />) : */}
            <Pnation isCustomFetch={false} onPeding={onPeding} onCngPage={getData} url='/agreements/list/' plod={searchKeyword} />
            {/* } */}
        </div>
    )
}
